export default __webpack_public_path__ + "static/media/PM_LOGO_FINAL-01.600646bc.png";